import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-section-template',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './section-template.component.html',
  styleUrl: './section-template.component.scss',
})
export class SectionTemplateComponent {
  theme = input<'grey' | 'white'>('white');
  sectionTitle = input<string>();
  hasPadding = input<boolean>(true);
  has32Padding = input<boolean>(false);
  fullHeight = input<boolean>(false);
  isSticky = input<boolean>(false);
  hasMinWidth = input<boolean>(false);


  @HostBinding('class.has-min-width')
  get isMinWidth() {
    return this.hasMinWidth();
  }

  @HostBinding('class.has-full-height')
  get isFullHeight() {
    return this.fullHeight();
  }

  @HostBinding('class.has-32padding')
  get is32Padding() {
    return this.has32Padding();
  }


  @HostBinding('class.has-padding')
  get isPadding() {
    return this.hasPadding();
  }

  @HostBinding('class.is-grey')
  get isGrey() {
    return this.theme() === 'grey';
  }


}
